export default __webpack_public_path__ + "static/media/ic_mypage.2d4d8c53.svg";